import { SurveyFragment, Unit_Of_Measure } from '@occc/graphql';
import { LinkItem, LinkChip } from '@occc-app/design-system';
import { awardHelper } from '@occc-app/offerHelpers/utils/awardHelper';
import { routeCreator as awardRouteCreator } from '@occc-app/routes/AwardCatalog/utils';
import { pluralize } from '@occc-app/lib/strings';

import { getWalletSteeringValue, routeCreator } from '../utils';

export const getBreadcrumbLinks = (name: string | undefined): LinkItem[] => [
  { to: routeCreator.list(), label: 'Wallets' },
  { key: routeCreator.details(name || 'id'), label: name || 'Loading...' },
];

export const getRangeValue = (min: number, max: number, unitOfMeasure: Unit_Of_Measure) => {
  const minValue = getWalletSteeringValue(min, unitOfMeasure);
  const maxValue = getWalletSteeringValue(max, unitOfMeasure);

  return `${minValue} - ${maxValue}`;
};

export const getSurveyAwardDetails = (survey?: SurveyFragment) => {
  if (survey?.award && awardHelper.isPointsAward(survey.award)) {
    return `${survey.award.points} ${pluralize(survey.award.points, 'point')}`;
  }

  if (survey?.award && awardHelper.isSurveyVouchersAward(survey.award)) {
    const link = awardRouteCreator.details(survey.award.voucheredOffer.id);

    return <LinkChip label={survey.award.voucheredOffer.name} href={link} />;
  }

  return null;
};
